module.exports = __webpack_public_path__ + "static/media/arrow-monolith.e18d4b13.svg";